import router from "../router";
import store from "../store";
import cookie from "@utils/store/cookie";
import {
  isWeixin
} from "@/utils";

export default function toLogin(push, backUrl) {
  // console.log("不是登录页")

  store.commit("LOGOUT");
  const {
    fullPath,
    name
  } = router.currentRoute;
  cookie.set("login_back_url", backUrl || fullPath);
  // 未登录，设置重定向地址
  // cookie.set("redirectTo", fullPath);
  if (isWeixin()) {
    if (name !== "Login") {
      console.log("不是登录页")
      push
        ?
        router.push({
          path: "/login",
          query: {
            redirect: backUrl,
            origin: "login"
          }
        }) :
        router.replace({
          path: "/login",
          query: {
            redirect: backUrl,
            origin: "login"
          }
        });
    }
  } else {
    if (name !== "Login") {
      console.log("不是登录页2")
      // if(name == 'Index') {
      //   console.log("首页不跳转")
      //   return;
      // }

      if(fullPath == '/') {
        console.log("纯首页不跳转")
        return;
      }

      push
        ?
        router.push({
          path: "/login",
          query: {
            redirect: fullPath,
            origin: "login"
          }
        }) :
        router.replace({
          path: "/login",
          query: {
            redirect: fullPath,
            origin: "login"
          }
        });
    }
  }
}
